import { Breakpoint } from '@altibox/design-system-component-lib';
import { range } from 'lodash';
import React from 'react';

import { i18n } from 'app/i18n';
import { HouseType } from 'app/pages/order/model/house-type';
import { OrderService } from 'app/pages/order/services/order-service';
import { largeHouseImageProps, mediumHouseImageProps, meshUnitImageProps } from 'app/resources/images';

import {
    StyledBuildingCardContainer,
    StyledCard,
    StyledDescription,
    StyledHouseImage,
    StyledInfoText,
    StyledMeshUnitImageWrapper,
    StyledSingleMeshUnitImage,
    StyledTitle,
} from './building-select-card.styled';

interface Props {
    houseType: HouseType;
    onButtonClick: () => void;
}

export const BuildingSelectCard: React.FC<Props> = (props) => {
    const { houseType, ...rest } = props;

    const getHouseImageProps = () => {
        switch (houseType) {
            case HouseType.LARGE_HOUSE:
                return largeHouseImageProps;
            case HouseType.MEDIUM_HOUSE:
                return mediumHouseImageProps;
            default:
                throw new Error(`Not support house type ${houseType}`);
        }
    };

    const renderMeshUnitImages = () => (
        <StyledMeshUnitImageWrapper>
            {range(OrderService.getNumberOfWifiUnitsByHouseType(houseType)).map((index) => (
                <StyledSingleMeshUnitImage key={index} {...meshUnitImageProps} />
            ))}
        </StyledMeshUnitImageWrapper>
    );

    return (
        <StyledCard buttonText={i18n.components.buildingSelectCard.seeRecommendations} {...rest}>
            <StyledBuildingCardContainer>
                <StyledHouseImage {...getHouseImageProps()} />
                <div>
                    <StyledTitle variant="paragraph1" component="p" maxBreakpoint={Breakpoint.TABLET}>
                        {i18n.components.buildingSelectCard.title[houseType]}
                    </StyledTitle>
                    <StyledInfoText variant="uiText2" component="p">
                        {i18n.components.buildingSelectCard.houseSize[houseType]}
                    </StyledInfoText>
                </div>
                <StyledMeshUnitImageWrapper>{renderMeshUnitImages()}</StyledMeshUnitImageWrapper>
                <StyledDescription variant="uiText3" component="p" maxBreakpoint={Breakpoint.TABLET}>
                    {i18n.components.buildingSelectCard.description[houseType]}
                </StyledDescription>
            </StyledBuildingCardContainer>
        </StyledCard>
    );
};
